import React, { useState } from 'react';
import styled from 'styled-components';
import robots from '../components/List_robots'; // ロボット一覧をインポート  
import { fetchNewtelemetry } from './api'; // API関数をインポート  

const Container = styled.div`  
  display: flex;  
  flex-direction: column;  
  padding: 0 20px 60px 20px;  
  background: #fafafa;  
  width: 100%;  
  margin: auto;  
  font-family: Arial, sans-serif;  
  box-sizing: border-box;  
  justify-content: flex-start;  
  align-items: stretch;  
  min-height: 100vh;  
`;

const Select = styled.select`  
  font-size: 16px;  
  padding: 8px;  
  margin-bottom: 20px;  
`;

const Button = styled.button`  
  width: 100%;  
  padding: 8px 16px;  
  font-size: 16px;  
  cursor: pointer;  
`;

const TableContainer = styled.div`  
  overflow-x: auto;  
  margin-top: 20px;  
`;

const Table = styled.table`  
  width: 100%;  
  border-collapse: collapse;  
`;

const Th = styled.th`  
  border: 1px solid #dddddd;  
  text-align: left;  
  padding: 8px;  
  white-space: nowrap; /* 改行しないように設定 */  
`;

const Td = styled.td`  
  border: 1px solid #dddddd;  
  text-align: left;  
  padding: 8px;  
  white-space: nowrap; /* 改行しないように設定 */  
`;

const Spinner = styled.div`  
  border: 4px solid rgba(0, 0, 0, 0.1);  
  border-left-color: #22a6b3;  
  border-radius: 50%;  
  width: 40px;  
  height: 40px;  
  animation: spin 1s linear infinite;  
  margin: 20px auto;  
  
  @keyframes spin {  
    to {  
      transform: rotate(360deg);  
    }  
  }  
`;

const Settings = () => {
    const [selectedRobotName, setSelectedRobotName] = useState('');
    const [newData, setNewData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [csvLoading, setCsvLoading] = useState(false); // CSV出力処理中の状態管理  

    const handleSelectChange = (event) => {
        const robotName = event.target.value;
        setSelectedRobotName(robotName);
        if (robotName) {
            setLoading(true);
            setError(null);
            setNewData([]); // 以前のデータをクリア  

            fetchNewtelemetry(robotName, 100)
                .then(data => {
                    console.log('Data fetched:', data);
                    setNewData(data);
                })
                .catch(e => {
                    console.error('Error fetching data:', e);
                    setError(e.message);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const getAllKeys = (data) => {
        const keys = new Set();
        data.forEach(item => {
            Object.keys(item).forEach(key => keys.add(key));
        });
        return Array.from(keys);
    };

    const allKeys = getAllKeys(newData);

    const keysToHide = ['id', 'uuid', 'Type', 'deviceId'];

    const exportToCSV = () => {
        if (!selectedRobotName) return;

        setCsvLoading(true); // CSV出力処理中の状態を設定  
        fetchNewtelemetry(selectedRobotName, 50000)
            .then(data => {
                const csvRows = [];
                const headers = ['項目', ...getAllKeys(data)];
                csvRows.push(headers.join(','));

                data.forEach((item, rowIndex) => {
                    const row = [rowIndex + 1];
                    headers.slice(1).forEach(key => {
                        row.push(item[key] !== undefined ? item[key] : '-');
                    });
                    csvRows.push(row.join(','));
                });

                const csvContent = csvRows.join('\n');
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `${selectedRobotName}_data.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(e => {
                console.error('Error fetching data for CSV:', e);
                setError(e.message);
            })
            .finally(() => {
                setCsvLoading(false); // CSV出力処理中の状態をリセット  
            });
    };

    return (
        <Container>
            <h2 style={{ color: '#333333', fontSize: '24px', fontWeight: 'bold' }}>
                Aiロボ
            </h2>
            <Select value={selectedRobotName} onChange={handleSelectChange}>
                <option value="">ロボットを選択してください</option>
                {robots.map((robot, index) => (
                    <option key={index} value={robot.name}>
                        {robot.name}
                    </option>
                ))}
            </Select>
            {selectedRobotName && (
                <div>
                    <Button onClick={exportToCSV} disabled={csvLoading}>
                        CSV出力
                    </Button>
                    {csvLoading && <Spinner />} {/* CSV出力処理中にスピナーを表示 */}
                    {loading && <p>Loading...</p>}
                    {error && <p>Error: {error}</p>}
                    <div>

                    </div>
                    <h1>直近100件のみ表示</h1>
                    {!loading && !error && (
                        <TableContainer>
                            <Table>
                                <thead>
                                    <tr>
                                        <Th>項目</Th>
                                        {allKeys.filter(key => !keysToHide.includes(key)).map((key, index) => (
                                            <Th key={index}>{key}</Th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {newData.map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <Td>{rowIndex + 1}</Td>
                                            {allKeys.filter(key => !keysToHide.includes(key)).map((key, colIndex) => (
                                                <Td key={colIndex}>{item[key] !== undefined ? item[key] : '-'}</Td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </TableContainer>
                    )}
                </div>
            )}
        </Container>
    );
};

export default Settings;  